import React, { ReactNode } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";


interface Props {
  controlProps: controls.PhotoTagGroup;
};

export const PNXTag = ({ tag }: { tag: string }) => {
  if (!tag) return "";
  return <div className="phoenix-forms-tag">{tag}</div>
};

const PhoenixPhotoTagGroup = ({
  controlProps,
} : Props) => {

  let photoTag: ReactNode = "";
  switch (controlProps.groupType) {
    case "autotag":
      photoTag = controlProps.tags.map(tag => <PNXTag key={tag} tag={tag} />);
      break;
    case "exprtag":
      photoTag = <PNXTag tag={controlProps.value} />;
      break;
    default:
      photoTag = "INVALID";
      break;
  }

  return photoTag;
};

export default PhoenixPhotoTagGroup;
